module.exports = __webpack_public_path__ + "img/img_4.9055f106.jpeg";